export class Cache {
  value: any;
  expire: Date;
}
